import { redirect } from 'react-router-dom';

import { getAllWorths } from 'src/services/getAllWorths';
import { getMe } from 'src/services/getMe';
import { baseLoader } from './baseLoader';
import { getQueryParams } from 'src/utils/helpers/queryParams';
import { parseSort } from 'src/hooks/filters/useSort';
import { parseFilters } from 'src/hooks/filters/useFilters';
import { normalizeUserRole } from 'src/utils/mappers/user.mapper';
import { isUnauthorizedError } from 'src/utils/helpers/isUnauthorizedError';
import { buildCompanyMenuUrl } from 'src/utils/data/company-statuses';
import { buildNoAccessPath } from '../constants';

export const getAllWorthsLoader = async ({ request }) => {
	let me;

	try {
		me = await getMe();
	} catch (error) {
		if (isUnauthorizedError(error)) {
			throw redirect(buildNoAccessPath(request));
		}

		throw error;
	}

	if (normalizeUserRole(me?.role) !== 'admin') {
		return redirect(buildCompanyMenuUrl('commission', 'inwork'));
	}

	const { limit, page } = getQueryParams({ request }, ['page', 'limit']);
	const params = new URL(request.url).searchParams;
	const queryParams = {
		page: Number(page) || 1,
		limit: Number(limit) || 15,
		sort: parseSort(params),
		filters: parseFilters(params),
	};

	return baseLoader(
		() => getAllWorths(queryParams),
		'Failed to load worths.',
		request,
	);
};
